export default {
    backend_url_users: "https://outlay-tracker.herokuapp.com/api/users/",
    backend_asset_url: "https://outlay-tracker.herokuapp.com/"
    
}